import state from './moduleMetadataState.js'
import mutations from './moduleMetadataMutations.js'
import actions from './moduleMetadataAction.js'
import getters from './moduleMetadataGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
